import { render, staticRenderFns } from "./FailureNoticeManage.vue?vue&type=template&id=92ca7f18&"
import script from "./FailureNoticeManage.vue?vue&type=script&lang=js&"
export * from "./FailureNoticeManage.vue?vue&type=script&lang=js&"
import style0 from "./FailureNoticeManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports